import { Box, Divider, Stack, TextField, Typography } from "@mui/material";
import TopHeadingDividerComponent from "../AccountSetting/TopHeadingDividerComponent";
import CustomizedRadios from "../Communications/CustomizedRadios";
import GroupFormRadios from "./GroupFormRadios";
import SaveChangingsButton from "../AccountSetting/SaveChangingsButton";
import { useState } from "react";
import api from "../../config/axios";  // Use configured axios instance
import { useNavigate } from "react-router-dom";

function CommunityGroupFormSection() {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    privacy: "public"
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePrivacyChange = (value) => {
    setFormData(prev => ({
      ...prev,
      privacy: value
    }));
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      alert("Please enter a group name");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    console.log("Create group button clicked");
    try {
      // Validate required fields
      if (!formData.name.trim()) {
        alert("Please enter a group name");
        return;
      }

      const token = localStorage.getItem("token");
      console.log("Token:", token);
      
      if (!token) {
        alert("You must be logged in to create a group");
        return;
      }

      console.log("Sending data to server:", formData);

      const response = await api.post("/groups", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log("Server response:", response.data);

      if (response.data) {
        alert("Group created successfully!");
        navigate("/community");
      }
    } catch (error) {
      console.error("Error creating group:", error);
      if (!error.response) {
        alert("Network error: Cannot connect to the server. Please check if the backend server is running at http://localhost:8000");
      } else {
        alert("Error creating group: " + (error.response?.data?.message || error.message));
      }
    }
  };

  return (
    <Stack
      sx={{
        bgcolor: "#ffffff",
        borderRadius: "22px",
        p: "20px",
      }}
    >
      {" "}
      <TopHeadingDividerComponent
        primary="Create new group"
        secondary="Based on your profile, preferences, and activity like applies, searches, and saves"
        divider={false}
        primaryBottomPadding="4px"
        secondaryBottomPadding="0px"
      />
      <Divider
        sx={{
          height: "1px",
          bgcolor: "#EBEBEB",
          border: "none",
          my: "18px",
          mx: "-20px",
        }}
      />
      <Box
        component="img"
        src="/images/groupFormPic.png"
        sx={{ borderRadius: "30px" }}
      ></Box>
      <Stack direction="row" sx={{ gap: "26px", pt: "36px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            flex: "1",
          }}
        >
          {" "}
          <Typography
            variant="body2"
            sx={{
              fontWeight: "400",
              fontSize: "18px",
              lineHeight: "100%",
              color: "#000000",
              fontFamily: "Inter",
              // pb: "8px",
            }}
          >
            Group name
          </Typography>
          <TextField
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            variant="outlined"
            sx={{
              //   width: "50%",
              // minWidth: "200px",

              input: {
                bgcolor: "#ffffff",
                color: "#AFAFAF",
                fontSize: "18px",
                boxSizing: "content-box",
                px: "4px",
                py: "12px",
                "&::placeholder": {
                  color: "#AFAFAF",
                },
              },
              "& .MuiOutlinedInput-root": {
                px: "8px",
                borderRadius: "10px",
                bgcolor: "#ffffff",
                "& fieldset": {
                  border: "1px solid #e3e3e3",
                }, // Outline color
                "&:hover fieldset": {
                  border: "1px solid #e3e3e3",
                }, // Hover state
                "&.Mui-focused fieldset": {
                  border: "1px solid #e3e3e3",
                }, // Focus state
              },
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            flex: "1",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: "400",
              fontSize: "18px",
              lineHeight: "100%",
              color: "#000000",
              // pb: "8px",
            }}
          >
            Choose privacy
          </Typography>
          <Stack
            sx={{
              px: "8px",
              py: "8px",
              borderRadius: "10px",
              border: "1px solid #E3E3E3",
              //   width: "50%",
            }}
          >
            <GroupFormRadios 
              value={formData.privacy}
              onChange={handlePrivacyChange}
            />
          </Stack>
        </Box>
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          py: "20px",
        }}
      >
        {" "}
        <Typography
          variant="body2"
          sx={{
            fontWeight: "400",
            fontSize: "18px",
            lineHeight: "100%",
            color: "#000000",
            fontFamily: "Inter",
            // pb: "8px",
          }}
        >
          Description
        </Typography>
        <TextField
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          sx={{
            textarea: {
              bgcolor: "#ffffff",
              color: "#AFAFAF",
              fontSize: "18px",
              boxSizing: "content-box",
              px: "4px",
              py: "12px",
              "&::placeholder": {
                color: "#AFAFAF",
              },
            },
            "& .MuiOutlinedInput-root": {
              px: "8px",
              borderRadius: "10px",
              bgcolor: "#ffffff",
              "& fieldset": {
                border: "1px solid #e3e3e3",
              },
              "&:hover fieldset": {
                border: "1px solid #e3e3e3",
              },
              "&.Mui-focused fieldset": {
                border: "1px solid #e3e3e3",
              },
            },
          }}
        />
      </Box>
      <Typography
        variant="body2"
        sx={{
          fontWeight: "400",
          fontSize: "18px",
          lineHeight: "100%",
          color: "#000000",
          maxWidth: "570px",
          fontFamily: "Inter",
          pb: "90px",
        }}
      >
        Anyone can see who's in the group and what they post. You can change
        your group to private now or at a later time
      </Typography>
      <SaveChangingsButton 
        onClick={() => {
          console.log("Button clicked");
          handleSubmit();
        }}
      >
        Create group
      </SaveChangingsButton>
    </Stack>
  );
}

export default CommunityGroupFormSection;
